module.exports = __webpack_public_path__ + "img/banner1-3.73ab8125.png";